import script from "./SelectInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectInput.vue?vue&type=script&setup=true&lang=js"

import "./SelectInput.vue?vue&type=style&index=0&id=6952526a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6952526a"]])

export default __exports__